module.exports = __webpack_public_path__ + "media/table@2x_db414a.png";